import React from 'react';
import './Table.css';
import numeral from "numeral";

//pass the props
function Table({ countries }) {
    return (
        <div className="table">
            {countries.map(({ country, cases }) => (

                <tr>
                    {/* <td>{country.country} and country.cases</td> if not structured in map */}
                    {/* {} inside of JSX for call JS */}
                    <td>{country}</td>
                    <td><strong>{numeral(cases).format("0,0")}</strong></td>
                </tr>

            ))}
        </div>
    );
}

export default Table;
